// extracted by mini-css-extract-plugin
export var infoItem = "_jq-1";
export var title = "_jq-0";